import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForCoreHeader } from "../../utils/createDisplayName";
import { createTestIdForCoreHeader } from "../../utils/createTestId";

import type { PropsWithTsId } from "../../../../../../types/react";

import classes from "./CoreHeaderLeftAddon.styl";

const LEFT_ADDON_TEST_ID = createTestIdForCoreHeader("left-addon");

export type CoreHeaderLeftAddonProps = FC<
    PropsWithChildren<Partial<PropsWithTsId>>
>;

export const CoreHeaderLeftAddon: CoreHeaderLeftAddonProps = ({
    children,
    "data-tsid": tsid = LEFT_ADDON_TEST_ID,
}): JSX.Element => {
    return (
        <div className={classes["left-addon"]} data-tsid={tsid}>
            {children}
        </div>
    );
};

CoreHeaderLeftAddon.displayName = createDisplayNameForCoreHeader("LeftAddon");

export default CoreHeaderLeftAddon;
